"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SortImg = _interopRequireDefault(require("../modules/SortImg.vue"));
var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/deliverGoods/freightSet/creatTemplates"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
var _internal = require("@/components/uploadPicture/internal.js");
var _enum = require("../../enum");
var _common = require("../common");
var _api = require("../api");
var _editStorebrandSupplier = _interopRequireDefault(require("@/views/store/storeBrand/editStorebrandSupplier.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'goodsInfo',
  components: {
    EditStorebrand: _editStorebrandSupplier.default,
    SortImgVue: _SortImg.default,
    CreatTemplatesVue: _creatTemplates.default
  },
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 控制资料证明区域显示逻辑
    // 当商品属性只选择普通商品(ptcp)或进口商品(jkcp)时不显示，其他情况显示
    showDocumentProof: function showDocumentProof() {
      var _this$comData$product, _this$comData$product2;
      var _this$form$productAtt = this.form.productAttr,
        productAttr = _this$form$productAtt === void 0 ? [] : _this$form$productAtt;
      // 如果没有选择任何属性，不显示
      if (!productAttr.length) return false;
      console.log(productAttr, this.comData.productAttrEnum.find(function (item) {
        return console.log(item);
      }));
      // 获取普通商品和进口商品的属性ID
      var normalProductId = (_this$comData$product = this.comData.productAttrEnum.find(function (item) {
        return item.name === '普通产品';
      })) === null || _this$comData$product === void 0 ? void 0 : _this$comData$product.id;
      var importedProductId = (_this$comData$product2 = this.comData.productAttrEnum.find(function (item) {
        return item.name === '进口产品';
      })) === null || _this$comData$product2 === void 0 ? void 0 : _this$comData$product2.id;
      console.log(normalProductId, importedProductId);
      // 如果只选了一个属性，且是普通商品或进口商品，则不显示
      if (productAttr.length === 1 && (productAttr[0] === normalProductId || productAttr[0] === importedProductId)) {
        return false;
      }

      // 如果只选了两个属性，且分别是普通商品和进口商品，则不显示
      if (productAttr.length === 2 && productAttr.includes(normalProductId) && productAttr.includes(importedProductId)) {
        return false;
      }

      // 其他情况显示
      return true;
    }
  },
  data: function data() {
    return {
      deliveryTimeEnum2: _enum.deliveryTimeEnum2,
      goodsTypeEnum2: _enum.goodsTypeEnum2,
      goodsStatusEnum: _enum.goodsStatusEnum,
      brandAuthEnum: _enum.brandAuthEnum,
      accountTypeEnum: _enum.accountTypeEnum,
      rechargeTypeEnum: _enum.rechargeTypeEnum,
      couponsGoodsAttrsEnum: _enum.couponsGoodsAttrsEnum,
      rules: _common.rules,
      props: _common.props,
      formConfig: _common.formConfig,
      comData: _common.comData,
      brandLoading: false,
      form: {
        showCateId: [],
        tempId: null,
        productType: 1,
        isShow: 0,
        sliderImages: [],
        productAttr: [],
        isQuota: null,
        documentation: '',
        // 存储资料证明文件URL，以逗号分隔
        quotaList: [{
          type: 1,
          checked: false,
          plan: null
        }, {
          type: 2,
          checked: false,
          plan: null
        }, {
          type: 3,
          checked: false,
          plan: null
        }, {
          type: 4,
          checked: false,
          plan: null
        }, {
          type: 5,
          checked: false,
          plan: null,
          time: []
        }]
      },
      ID: this.$route.params.id,
      documentationFiles: [] // 新增：用于存储文档证明文件列表
    };
  },
  watch: {
    form: {
      handler: function handler(newVal, oldVal) {
        this.$emit('formChange', newVal);
        // console.log('form changed:', newVal, oldVal);
        // 在这里编写你需要的逻辑
      },
      deep: true
    },
    cloneForm: {
      handler: function handler(newForm) {
        this.form = _objectSpread(_objectSpread(_objectSpread({}, this.form), newForm), this.getSendTime(newForm.deliveryTime));
        // 处理文档回显
        if (newForm.documentation) {
          // 处理从字符串格式获取URLs
          var docUrls = newForm.documentation.split(',').filter(function (url) {
            return url.trim() !== '';
          });

          // 处理文件名数据
          var docNames = [];
          if (newForm.documentationName) {
            try {
              // 尝试解析JSON字符串
              docNames = JSON.parse(newForm.documentationName);
            } catch (e) {
              // 如果解析失败，尝试以逗号分隔的字符串解析
              docNames = newForm.documentationName.split(',');
            }
          }

          // 生成用于显示的文件列表
          this.documentationFiles = docUrls.map(function (url, index) {
            return {
              name: docNames && docNames[index] ? docNames[index] : url.substring(url.lastIndexOf('/') + 1),
              url: url,
              size: 0 // 默认大小
            };
          });
        }
        // 由于供应商下拉列表已隐藏，不再需要根据supplierId获取供应商列表
        // 但仍然需要获取品牌列表
        if (newForm !== null && newForm !== void 0 && newForm.supplierId) {
          setTimeout(function () {
            (0, _common.getBrandList)('', newForm === null || newForm === void 0 ? void 0 : newForm.supplierId);
          }, 300);
        }
      }
    },
    'form.productType': {
      handler: function handler(productType) {
        if (productType && [1, 2].includes(Number(productType))) {
          // 由于供应商下拉列表已隐藏，不再需要根据productType获取供应商列表
          // 但可能需要根据productType执行其他逻辑
        }
      },
      immediate: true,
      deep: true
    },
    'form.supplierId': {
      handler: function handler(supplierId) {
        var _this2 = this;
        if (supplierId) {
          this.brandLoading = true;
          (0, _common.getBrandList)('', supplierId);
          setTimeout(function () {
            _this2.brandLoading = false;
          }, 1500);
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    // 获取运费模板列表，并设置默认选中"标准模板"
    this.getShippingTemplates();
  },
  methods: {
    throttle: _throttle.default,
    getBrandList: _common.getBrandList,
    getShippingList: _common.getShippingList,
    validate: _common.validate,
    //新增品牌
    handlerOpenEdit: function handlerOpenEdit(editId) {
      this.$refs['EditStorebrandRef'].openInit(editId);
    },
    // 刷新品牌列表数据（响应EditStorebrand组件的doRefresh事件）
    handlerGetListData: function handlerGetListData() {
      // 重新获取品牌列表，如果有supplierId则传入，否则获取全部
      (0, _common.getBrandList)('', this.form.supplierId || '');
    },
    // 验证轮播图是否有值
    validateSliderImages: function validateSliderImages(rule, value, callback) {
      if (!value || value.length < 3) {
        return callback(new Error('请至少上传三张商品图片'));
      }
      callback();
    },
    // 获取运费模板并设置默认值
    getShippingTemplates: function getShippingTemplates() {
      var _this3 = this;
      (0, _common.getShippingList)({
        page: 1,
        limit: 999
      });
      // 使用setTimeout等待数据加载完成后再设置默认模板
      setTimeout(function () {
        _this3.setDefaultTemplate();
      }, 2000);
    },
    // 设置默认运费模板
    setDefaultTemplate: function setDefaultTemplate() {
      if (this.comData.shippingList && this.comData.shippingList.length > 0) {
        var standardTemplate = this.comData.shippingList.find(function (item) {
          return item.name === '标准模板';
        });
        if (standardTemplate) {
          this.form.tempId = standardTemplate.id;
        }
      }
    },
    remoteMethod: function remoteMethod(query) {
      // getSupplierList(query)
    },
    brandRemoteMethod: function brandRemoteMethod(query) {
      (0, _common.getBrandList)(query);
    },
    changeSliderImages: function changeSliderImages(data) {
      this.form.sliderImages = data;
    },
    brandVisibleChange: function brandVisibleChange(status) {
      if (status) return;
      (0, _common.getBrandList)('', this.form.supplierId);
    },
    // 搜索供应商
    handleSupplierSearch: function handleSupplierSearch(data) {
      this.throttle(function () {
        (0, _common.getSupplierList)(data);
      }, 300)();
    },
    supplierVisibleChange: function supplierVisibleChange(status) {
      //  if(status) return;
      //  getSupplierList()
    },
    /**
     * 获取商品信息spucode
     */
    getSpuCode: function () {
      var _getSpuCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _cateIdsObj$;
        var cateIdsObj, _this$form, storeName, brandIdObj, id, brandName, params, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              cateIdsObj = this.$refs['cateIdsRef'].getCheckedNodes();
              if (!(cateIdsObj && !(cateIdsObj !== null && cateIdsObj !== void 0 && cateIdsObj.length))) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this$form = this.form, storeName = _this$form.storeName, brandIdObj = _this$form.brandIdObj, id = _this$form.id;
              if (brandIdObj) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              brandName = brandIdObj.brandName;
              params = {
                cateName: (_cateIdsObj$ = cateIdsObj[0]) === null || _cateIdsObj$ === void 0 ? void 0 : _cateIdsObj$.data.name,
                brandName: brandName,
                spuName: storeName
              };
              if (!(!params.spuName || id)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.p = 3;
              _context.n = 4;
              return (0, _api.generateSPUCodeApi)(params);
            case 4:
              res = _context.v;
              if (res.code) {
                this.$set(this.form, 'spuCode', "".concat(res.code).concat(res.extraNum));
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              this.$message.error(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5]]);
      }));
      function getSpuCode() {
        return _getSpuCode.apply(this, arguments);
      }
      return getSpuCode;
    }(),
    /**
     * 上传图片
     */
    upLoadSliderImages: function upLoadSliderImages() {
      var _this$form$sliderImag;
      var _this = this;

      // 计算还可以上传多少张图片
      var maxCount = 10;
      var remainingSlots = maxCount - (((_this$form$sliderImag = _this.form.sliderImages) === null || _this$form$sliderImag === void 0 ? void 0 : _this$form$sliderImag.length) || 0);
      if (remainingSlots <= 0) {
        _this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(maxCount, "\u5F20\u56FE\u7247\uFF01"));
        return;
      }
      (0, _internal.uploadLocalImage)({
        multiple: true,
        maxCount: remainingSlots,
        model: 'product',
        pid: 1,
        validateAspectRatio: true,
        maxSizeKB: 500,
        maxSizeErrorMsg: '请上传大小≤500KB的图片！',
        onSuccess: function onSuccess(url) {
          // 上传成功，添加到图片列表
          if (!_this.form.sliderImages) {
            _this.form.sliderImages = [];
          }
          _this.form.sliderImages.push(url);
        },
        onComplete: function onComplete(successUrls) {
          if (successUrls && successUrls.length > 0) {
            _this.$message.success("\u6210\u529F\u4E0A\u4F20".concat(successUrls.length, "\u5F20\u56FE\u7247"));
          } else {
            // _this.$message.warning('没有图片上传成功');
          }
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '图片上传失败');
        }
      });
    },
    /**
     *  运费模板
     */
    addTem: function addTem() {
      var creatTemplatesVueRef = this.$refs.creatTemplatesVueRef;
      creatTemplatesVueRef.dialogVisible = true;
      creatTemplatesVueRef.getCityList();
    },
    addCate: function addCate() {
      this.$router.push({
        path: '/store/sort/ordinary'
      });
    },
    addShowCate: function addShowCate() {
      this.$router.push({
        path: '/store/sort/show'
      });
    },
    //回显发货时间
    getSendTime: function getSendTime(time) {
      if (this.ID && time) {
        var arr = this.deliveryTimeEnum2.map(function (item) {
          return item.value;
        });
        var flag = !arr.includes(time);
        return {
          deliveryTime: flag ? 'other' : time,
          deliveryTimeOther: flag ? String(time) : ''
        };
      } else {
        return {};
      }
    },
    deliveryTimeChange: function deliveryTimeChange(value) {
      if (value !== 'other') {
        this.form.deliveryTimeOther = '';
      }
    },
    /**
     * 上传文档证明文件
     */
    handleDocumentUpload: function handleDocumentUpload(options) {
      var _this4 = this;
      var file = options.file;
      var formData = new FormData();
      formData.append('multipart', file);
      var params = {
        model: 'product',
        // 使用product模块
        pid: this.ID || 0
      };
      var loading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
        loading.close();
        if (response && response.url) {
          // 将文件URL添加到documentation字符串中，以逗号分隔
          var updatedDocumentation = '';
          var updatedDocumentationName = '';
          if (!_this4.form.documentation) {
            updatedDocumentation = response.url;
            updatedDocumentationName = file.name;
          } else {
            // 已有URL，添加逗号分隔符
            updatedDocumentation = _this4.form.documentation.trim();
            if (!updatedDocumentation.endsWith(',')) {
              updatedDocumentation += ',';
            }
            updatedDocumentation += response.url;

            // 处理文件名
            updatedDocumentationName = _this4.form.documentationName || '';
            if (updatedDocumentationName) {
              if (!updatedDocumentationName.endsWith(',')) {
                updatedDocumentationName += ',';
              }
            }
            updatedDocumentationName += file.name;
          }

          // 使用Vue的$set方法确保响应性
          _this4.$set(_this4.form, 'documentation', updatedDocumentation);
          _this4.$set(_this4.form, 'documentationName', updatedDocumentationName);
          console.log("\u6587\u4EF6\u4E0A\u4F20\u6210\u529F: ".concat(response.url, "\uFF0C\u5F53\u524D\u6587\u6863\u5217\u8868: ").concat(_this4.form.documentation));

          // 更新文件列表显示
          _this4.documentationFiles.push({
            name: file.name,
            // 使用原始文件名
            url: response.url,
            size: file.size || 0
          });

          // 确保变更被捕获
          _this4.$nextTick(function () {
            _this4.$emit('formChange', _objectSpread({}, _this4.form));
          });
          _this4.$message.success("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u6210\u529F"));
        } else {
          _this4.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: \u670D\u52A1\u5668\u8FD4\u56DE\u9519\u8BEF"));
        }
      }).catch(function (error) {
        loading.close();
        _this4.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: ").concat(error.message || '未知错误'));
      });
    },
    /**
     * 预览文档证明文件
     */
    handlePreviewDocument: function handlePreviewDocument(file) {
      window.open(file.url, '_blank');
    },
    /**
     * 移除文档证明文件
     */
    handleRemoveDocument: function handleRemoveDocument(file) {
      var _this5 = this;
      // 从documentationFiles中移除文件
      var displayIndex = this.documentationFiles.findIndex(function (f) {
        return f.url === file.url;
      });
      if (displayIndex !== -1) {
        this.documentationFiles.splice(displayIndex, 1);
      }

      // 从form.documentation中移除文件URL
      if (this.form.documentation) {
        // 将字符串分割为数组
        var urls = this.form.documentation.split(',').filter(function (url) {
          return url.trim() !== '';
        });
        var urlIndex = urls.findIndex(function (url) {
          return url === file.url;
        });
        // 移除目标URL
        var updatedUrls = urls.filter(function (_, idx) {
          return idx !== urlIndex;
        });
        // 重新组合为逗号分隔字符串
        var updatedDocumentation = updatedUrls.join(',');

        // 使用Vue的$set方法确保响应性
        this.$set(this.form, 'documentation', updatedDocumentation);

        // 更新documentationName
        if (this.form.documentationName) {
          var names = [];
          try {
            // 尝试解析JSON字符串
            names = JSON.parse(this.form.documentationName);
          } catch (e) {
            // 如果解析失败，尝试以逗号分隔的字符串解析
            names = this.form.documentationName.split(',');
          }

          // 移除对应索引的名称
          if (urlIndex !== -1 && names.length > urlIndex) {
            names.splice(urlIndex, 1);
            this.$set(this.form, 'documentationName', names.join(','));
          }
        }
        console.log("\u6587\u4EF6\u5DF2\u5220\u9664: ".concat(file.url, "\uFF0C\u5F53\u524D\u6587\u6863\u5217\u8868: ").concat(this.form.documentation));

        // 确保变更被捕获
        this.$nextTick(function () {
          _this5.$emit('formChange', _objectSpread({}, _this5.form));
        });
      }
    }
  }
};